import { t } from "@lingui/core/macro";
import { CustomCellStatic, CustomCellLink } from "_/components/table";
import { routeUrls } from "_/routes";
import { Machine } from "_/data/machines";
import { Permission } from "_/data/rbac";
import { testPermissions } from "_/components/permission-test";
import { BuildsetTooltip } from "_/components/buildsetTooltip";
import * as S from "./styled";

export const ChannelCell = ({
  rowData,
  userPermissions,
}: {
  rowData: Machine;
  userPermissions: Permission[];
}) => {
  const { buildsetPin, pinReason, updateChannel } = rowData;

  if (buildsetPin) {
    const tooltip = pinReason
      ? `${t`common.pin-reason`}: ${pinReason}`
      : undefined;
    return (
      <CustomCellStatic>
        <BuildsetTooltip id={tooltip}>
          <S.PinnedChannel>{updateChannel ?? "--"}</S.PinnedChannel>
        </BuildsetTooltip>
      </CustomCellStatic>
    );
  }

  const canReadSoftware = testPermissions(
    ["channels/read", "buildSets/read"],
    userPermissions
  );
  if (canReadSoftware) {
    return (
      <CustomCellLink to={routeUrls.admin.software}>
        {updateChannel ?? "--"}
      </CustomCellLink>
    );
  }

  return <CustomCellStatic>{updateChannel ?? "--"}</CustomCellStatic>;
};
